import { deleteAxios, get, post } from "@/stores/dataManager/axios/axiosIndex";
import { axiosType } from "../../dataStore/memoryStore/const/constIndex"
import { getConfigFromWindowBrowser } from "@/utilities/utils";
import { ENV } from "@/utilities/EWindow";
import { SubmitFavMaster } from "@/controllers/gridManager/followerTransManager/followerTransManager";
const API_MARKET_URL = getConfigFromWindowBrowser(ENV.API_MARKET_URL)

const API = getConfigFromWindowBrowser(ENV.BASE_URL) ?? ''


const apiType = axiosType.CLIENT

const userDataService = {

    getAccountInfoMF(params: { config: {}; accountId: string; }) {
        // console.log('getSymbolInfo: get api', new Date().getTime())
        const { accountId } = params
        const options: any = {}
        const config: any = params?.config
        return get(apiType, `${API}/cosapi/api/masters/accounts/${accountId}/accountInfo`, options, config);
    },

    registerFollower(params: { config: {}; accountId: string, dataVerify: any }) {
        const { accountId } = params
        const config: any = params?.config
        const data = {
            linkAccount: accountId,
            ...params?.dataVerify
        }
        return post(apiType, `${API}/cosapi/api/followers/register`, data, config);
    },

    registerMasters(params: { config: {} }, body: {
        linkAccount: string,
        tokenid: string,
        transactionId: string,
        authtype: string,
        code: string,
        isSaveVerify: boolean
    }) {
        const config: any = params?.config
        return post(apiType, `${API}/cosapi/api/masters/register`, body, config);
    },

    copyMaster(params: { config: {}; body: any; dataVerify: any }) {
        const { body } = params
        const { accountId, ...subBody } = body
        const config: any = params?.config
        const authBody = {
            ...subBody,
            ...params?.dataVerify
        }

        return post(apiType, `${API}/cosapi/api/followers/accounts/${accountId}/copy`, authBody, config);
    },

    extendCopier(params: { config: {}; dataVerify: any, body: { accountId: string, masterAccount: string, amount: number, linkAccount: string }; }) {
        const { body } = params
        const { accountId, ...subBody } = body
        const config: any = params?.config
        const authBody = {
            ...subBody,
            ...params?.dataVerify
        }
        return post(apiType, `${API}/cosapi/api/followers/accounts/${accountId}/depositCash`, authBody, config);
    },

    stopCopy(params: { config: {}; body: { accountId: string, masterAccount: string, option: string }, dataVerify: any }) {
        const { body } = params
        const { accountId, ...subBody } = body
        const config: any = params?.config
        const authBody = {
            ...subBody,
            ...params?.dataVerify
        }
        return post(apiType, `${API}/cosapi/api/followers/accounts/${accountId}/unCopy`, authBody, config);
    },

    deleteAccountFollower(params: { config: {}; accountId: string, dataVerify: any }) {
        const { accountId } = params
        const config: any = params?.config
        const authBody = {
            ...params?.dataVerify ?? {}
        }
        return post(apiType, `${API}/cosapi/api/followers/accounts/${accountId}/unregister`, authBody, config);
    },

    deleteAccountMaster(params: { 
        config: {},
        body: {
            tokenid: string,
            transactionId: string,
            authtype: string,
            code: string,
            isSaveVerify: boolean
        }, accountId: string
    }) {
        const { accountId } = params
        const config: any = params?.config
        const body: any = params?.body
        return post(apiType, `${API}/cosapi/api/masters/accounts/${accountId}/unregister`, body, config);
    },

    favMasterAccount(params: { config: {}; body: SubmitFavMaster }) {
        const { body } = params
        const cvBody = {
            mtCustodycd: body.masterCustodycd ?? '',
            mtAcctno: body.masterAccountId ?? '',
            action: body.action ?? '',
        }
        const config: any = params?.config
        return post(apiType, `${API}/cosapi/api/followers/accounts/${body.accountId ?? ''}/favMaster`, cvBody, config);
    },

    withdrawCash(params: { config: {}; body: { accountId: string, masterAccount: string, amount: number, linkAccount: string }, dataVerify: any }) {
        const { body } = params
        const cvBody = {
            masterAccount: body?.masterAccount,
            amount: body?.amount,
            linkAccount: body?.linkAccount,
        }

        const authBody = {
            ...cvBody,
            ...params?.dataVerify
        }
        const config: any = params?.config
        return post(apiType, `${API}/cosapi/api/followers/accounts/${body.accountId ?? ''}/withdrawCash`, authBody, config);
    },

    updateCopyMaster(params: { config: {}; body: { accountId: string, body: any, dataVerify: any }; }) {
        const { body } = params
        const { accountId } = body
        const config: any = params?.config
        const authBody = {
            ...body?.body,
            ...body?.dataVerify ?? {}
        }
        return post(apiType, `${API}/cosapi/api/followers/accounts/${accountId}/set-copy-cfg`, authBody, config);
    },
};

export default userDataService;